import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import HorizontalScroller from './../../alpineComponents/horizontalScroller';
import TextAndImage from './../../alpineComponents/textAndImage';
import ContactInfo from './../../components/contactInfo';
import { Link } from "react-router-dom";
import  './../../utils/analytics';

export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <div className="light-grey-background">
        <Hero
  				subtitle={'PILATES AVENUE'}
  				title={'the place for classical pilates'}
  				backgroundImage={'images/about-hero-reformers.jpg'}
  				height={'threequarter'} /*full, half,threequarter*/
          subtitlePosition={'top'}
          tint={'dark'}
        />
        <div className="small-max-width-container centered-text section-padding" style={{paddingBottom: "0px"}}>
          <CenteredParagraph
            title={"Welcome to Pilates Avenue Los Gatos"}
            description={"At Pilates Avenue, we give you personalized attention in a private comfortable setting. Here, you can focus exclusively on your customized workout. We use Gratz equipment, the original manufacturer of Pilates apparatus. Designed from specifications by Joseph Pilates himself, the equipment maximizes the benefits you'll reap from practicing Pilates. The various studio apparatus was designed to help with the more challenging matwork. This allows the instructor to train you in various ways to strengthen and stretch your body. If your body is not ready to do an exercise on one apparatus, then we use another to help you get there. Work hard. You'll see that just about anything is possible! "}
          />
        </div>
        <div className="section-padding" style={{paddingBottom:"0px"}}>
          <div className="max-width-container white-background">
            <TextAndImage
              ratio={'square'}/*square, rectangle*/
              direction={'left'}/*left, right*/
              image={'images/about-nancy.jpg'}
              title={'NANCY CHIN'}
              content={
                <div className="subheading">
                  <p>{'Pilates Avenue is owned by Nancy Chin and has been teaching Pilates since 2001. She is a graduate of The Work, an intensive program for certified teachers directed by first generation master instructor Jay Grimes -- who studied with Joseph Pilates himself. She continues to study with Jay, as well as other notable teachers including Sonje Mayo, who also studied with Joseph Pilates.'}</p>
                  <p style={{marginTop:'30px'}}>{'Nancy was originally trained in classical Pilates by Romana-trained Allison Gonzalez of Power Pilates, and was certified in New York City by Bob Liekens. Prior to that, she earned certifications from various organizations which took a more rehabilitative approach to the Pilates method. She also is certified as an exercise physiologist and personal trainer. Nancy is also certified in prenatal exercise and is the mother of three. She holds a B.S. degree in kinesiology and psychology from UCLA. Pilates Avenue was selected as a'}
                    <a target="_blank" href="https://www.pilates-gratz.com/pages/featured-studio-series-december-2014-pilates-avenue"><b>{' Gratz featured studio of the month'}</b></a>
                    {', and Nancy was selected as featured instructor of the month in'}
                    <a target="_blank" href="https://www.pilates-gratz.com/pages/gratz-gallery-nancy-chin-on-the-cadillac"><b>{' Gratz Gallery'}</b></a>
                    {'. Nancy believes that people are often capable of much more than they think.'}</p>
                  <p style={{marginTop:'30px'}}>{'*Additional instructors available as independent contractors.'}</p>
                </div>
              }
            />
            <TextAndImage
              ratio={'square'}/*square, rectangle*/
              direction={'right'}/*left, right*/
              image={'images/about-cadillac.jpg'}
              title={'GRATZ GALLERY | NANCY CHIN ON THE CADILLAC'}
              content={
                <div className="subheading">
                  <p>{'CADILLAC // - Thigh Stretch on the Cadillac stretches more than the thighs. It lengthens the whole spine. At the same time, it helps strengthen the abdominals, seat and the whole back side of the body. Great example of the benefits of Pilates -- stretch and strength at the same time.'}</p>
                  <p style={{marginTop:'30px'}}>{'"It has been six months since my total hip replacement. Gratz apparatus really helped me rebuild my strength so I feel better than ever." –Nancy Chin'}</p>
                </div>
              }
            />
          </div>
          <div className="medium-padding">
            <div className="small-padding centered-text">
              <h4>{'Gratz Featured Studio'}</h4>
            </div>
            <div className="max-width-container white-background">
              <div class='embed-container'><iframe src='https://www.youtube.com/embed/-O5iCcIzi7Y' frameborder='0' allowfullscreen></iframe></div>
            </div>
          </div>
          <div className="section-padding max-width-container"  style={{paddingTop:"0px"}}>
            <div className="white-background">
              <TextAndImage
                ratio={'square'}/*square, rectangle*/
                direction={'left'}/*left, right*/
                image={'images/about-pilates.jpg'}
                description={'The Pilates method is a physical fitness system developed in the early 20th century by Joseph Pilates. Originally named Contrology, this form of conditioning was designed to strengthen the core of the body: abdominals, hips, buttocks and back. You\'ll find it improves muscle tone, flexibility, posture and balance. Regular practice can relieve back pain and strengthen the pelvic floor. Pilates can be adapted for those with joint replacement, osteoporosis or previous injury and is suitable for all fitness levels. Plus it can boost performance in dance and just about any sport. You\'ll feel and see the difference!'}
              />
              <TextAndImage
                ratio={'square'}/*square, rectangle*/
                direction={'right'}/*left, right*/
                image={'images/about-matwork.jpg'}
                description={'Matwork is the foundation of the Pilates system. Requiring no equipment, the exercises are done on a floor mat and recruit your own body weight as resistance. We are fully equipped with various Pilates apparatus. This studio equipment uses resistance from springs and pulleys to add support or to challenge. Whether working out on the mat or on the apparatus, Pilates uses an oppositional pull to lengthen the spine and body. That\'s what makes for that long, lean Pilates body. '}
              />
            </div>
          </div>
          <div className="max-width-container">
            <div className="small-padding primary-background shadow full-height relative centered-text">
              <h4 className="white">{'Start Your Pilates Journey'}</h4>
              <p className="white">{'Choose from a variety of class formats including online and in studio'}</p>
              <Link to="/services">
                <h6 className="button" style={{backgroundColor:'#fff',color:"#ee6725", marginTop:'40px'}}>{'View Services'}</h6>
              </Link>
            </div>
          </div>
          <HorizontalScroller>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-1.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-2.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-3.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-4.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-5.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-6.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-7.jpg" />
            </div>
            <div className="small-padding">
              <img style={{height:'40vh'}} src="/images/gallery-8.jpg" />
            </div>
          </HorizontalScroller>
        </div>
      </div>
    </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/index.js